import React, { Children } from 'react';
import { Coffee, Croissant, GlassWater } from 'lucide-react';
import { motion } from 'framer-motion';
const features = [{
  icon: Coffee,
  title: 'Expertly Brewed',
  description: 'Carefully sourced beans roasted to perfection for your daily ritual.'
}, {
  icon: Croissant,
  title: 'Homemade Treats',
  description: 'Freshly baked pastries and comforting bites made with love daily.'
}, {
  icon: GlassWater,
  title: 'Shake Specials',
  description: 'Signature blended drinks and seasonal specials to cool you down.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.8
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function Features() {
  return <motion.div variants={containerVariants} initial="hidden" animate="visible" className="w-full max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 py-12 px-6" data-id="element-18">
      {features.map((feature, index) => <motion.div key={index} variants={itemVariants} className="flex flex-col items-center text-center group" data-id="element-19">
          <div className="w-16 h-16 rounded-full bg-mocha/30 border border-pale/10 flex items-center justify-center mb-6 text-red group-hover:bg-red/10 group-hover:border-red/30 transition-all duration-500" data-id="element-20">
            <feature.icon size={28} strokeWidth={1.5} data-id="element-21" />
          </div>
          <h3 className="font-serif text-xl text-cream mb-3" data-id="element-22">
            {feature.title}
          </h3>
          <p className="font-sans text-sm text-pale/80 leading-relaxed max-w-[250px]" data-id="element-23">
            {feature.description}
          </p>
        </motion.div>)}
    </motion.div>;
}